/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_B2_TitleInputs */

const en_simple_oto_b2_title = /** @type {(inputs: Simple_Oto_B2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Bystep builds`)
};

const id_simple_oto_b2_title = /** @type {(inputs: Simple_Oto_B2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Bystep bangun`)
};

/**
* | output |
* | --- |
* | "2. Bystep builds" |
*
* @param {Simple_Oto_B2_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_b2_title = /** @type {((inputs?: Simple_Oto_B2_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_B2_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_b2_title(inputs)
	return en_simple_oto_b2_title(inputs)
});